<script setup lang="ts"></script>

<template>
  <div class="wrapper">
    <slot />
    <div class="dropdown">
      <div class="dropdown-contents">
        <slot name="contents" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.wrapper {
  position: relative;
  display: inline-block;
  z-index: 10;
}

.dropdown {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  width: 200px;
  right: 0;
  top: 100%;
  padding-top: 0.5rem;
  transition: opacity 0.15s, visibility 0.15s;
}

.dropdown-contents {
  display: flex;
  flex-direction: column;
  background: var(--background);
  gap: 0;
  padding: 0.25rem;
  border-radius: 8px;
  border: 1px solid var(--border);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.dropdown-contents :deep(a),
.dropdown-contents :deep(button) {
  display: block;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--foreground);
  text-decoration: none;
  border-radius: 6px;
  transition: background 0.15s;
  text-align: left;
  width: 100%;
  border: none;
  background: transparent;
  cursor: pointer;
}

.dropdown-contents :deep(a):hover,
.dropdown-contents :deep(button):hover {
  background: var(--muted);
}

.wrapper:hover .dropdown {
  opacity: 1;
  visibility: visible;
}
</style>
